/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import { Divider } from '@mui/material';
import {
  $applyNodeReplacement,
  DecoratorNode,
  LexicalNode,
  Spread,
} from 'lexical';

import type {
  DOMConversionMap,
  DOMConversionOutput,
  NodeKey,
  SerializedLexicalNode,
} from 'lexical';

export type SerializedSeparatorNode = Spread<
  {
    type: 'separator';
  },
  SerializedLexicalNode
>;

function SeparatorComponent() {
  return <Divider />;
}

function convertElement(domNode: Node): null | DOMConversionOutput {
  if (domNode instanceof HTMLHRElement) {
    const node = $createSeparatorNode();
    return { node };
  }
  return null;
}

export class SeparatorNode extends DecoratorNode<JSX.Element> {
  static getType(): string {
    return 'separator';
  }

  static clone(node: SeparatorNode): SeparatorNode {
    return new SeparatorNode(node.__key);
  }

  static importJSON(): SeparatorNode {
    const node = $createSeparatorNode();
    return node;
  }

  static importDOM(): DOMConversionMap | null {
    return {
      hr: (node: Node) => ({
        conversion: convertElement,
        priority: 0,
      }),
    };
  }

  exportJSON(): SerializedSeparatorNode {
    return {
      type: 'separator',
      version: 1,
    };
  }

  createDOM(): HTMLElement {
    const div = document.createElement('div');
    const className = 'separator';
    if (className !== undefined) {
      div.className = className;
    }
    return div;
  }

  updateDOM(): false {
    return false;
  }

  getSrc(): string {
    return this.__src;
  }

  getAltText(): string {
    return this.__altText;
  }

  decorate(): JSX.Element {
    return (<SeparatorComponent />);
  }
}

export function $createSeparatorNode(key?: NodeKey): SeparatorNode {
  return $applyNodeReplacement(new SeparatorNode(key));
}

export function $isSeparatorNode(
  node: LexicalNode | null | undefined,
): node is SeparatorNode {
  return node instanceof SeparatorNode;
}
